import BgImage from 'assets/images/hero/hero-bg.png'
import logoImage from 'assets/images/hero/hero-nma-logo.png'

const Hero = () => {
  return (
    <>
      <div className="w-full h-[410px] relative overflow-hidden">
        <h1 className="absolute z-20 top-[170px] left-[72px] text-nowrap text-white  italic text-[44px] leading-[56px] tracking-[-5%] whitespace-break-spaces">
          Celebrating the <strong>daring</strong>, the <strong>disruptive</strong> <br /> and the
          <strong> exceptional</strong> in marketing.
        </h1>
        <img className="z-20 absolute top-[72px] left-[79px]" src={logoImage} alt="" />
        <div className="absolute w-full h-full top-0 left-0">
          <img src={BgImage} alt="Bg" />
        </div>
      </div>
      <div className="relative z-30 w-[1040px] h-[120px] mx-auto">
        {/* <div className="absolute -top-[58%] w-full mx-auto">
          <Countdown countdownDate="2 December 2025 15:00" />
        </div> */}
      </div>
    </>
  )
}

export default Hero
